/** Page size for flowsheet list / infinite query (must match backend pagination). */
export const FLOWSHEET_PAGE_SIZE = 20;

/** Shown as `dj_name` until WhoIsLive refetches after join. */
export const FLOWSHEET_OPTIMISTIC_DJ_PLACEHOLDER = "Live";

/** Empty / off-air summary label (keep in sync with API copy). */
export const OFF_AIR_LABEL = "Off Air";
